module.exports = __webpack_public_path__ + "img/risks-memory-loss.98d34d7b.svg";